module.exports = __webpack_public_path__ + "img/456.2cac0100.png";